import functionnal from "./functionnal.js";
const floatStringToIntegerCent = (floatString) => {
    if (typeof floatString !== "string") {
        throw new Error("floatStringToIntegerCent should be provided with a string, got " +
            floatString +
            " instead");
    }
    if (Number.isNaN(Number.parseFloat(floatString.replace(",", ".")))) {
        return;
    }
    if (floatString === "" || floatString === "-") {
        return 0;
    }
    return Math.round(Number.parseFloat(floatString.replace(",", ".")) * 100);
};
const integerCentToFloatString = (integerCent) => {
    if (typeof integerCent !== "number") {
        return;
    }
    const hasMinus = integerCent < 0;
    const unsignedPart = Math.abs(integerCent);
    const integerPart = unsignedPart.toString().slice(0, -2)
        ? unsignedPart.toString().slice(0, -2)
        : 0;
    const decimalPart = unsignedPart.toString().slice(-2);
    const doubleZeroReplace = (str) => (str === "00" ? "" : str);
    const oneDecReplace = (str) => (str.length === 1 ? "0" + str : str);
    return ((hasMinus ? "-" : "") +
        integerPart +
        (doubleZeroReplace(oneDecReplace(decimalPart)) ? "." : "") +
        doubleZeroReplace(oneDecReplace(decimalPart)));
};
const unsafeIntegerCentToFloatString = (integerCent) => integerCentToFloatString(integerCent);
const unsafeFloatStringToIntegerCent = (floatString) => floatStringToIntegerCent(floatString);
const floatStringIsPositive = (floatString) => {
    console.log("floatString", floatString);
    const integerCent = floatStringToIntegerCent(floatString);
    if (integerCent == null) {
        throw new Error("provided floatString in floatStringIsPositive is not valid");
    }
    return integerCent > 0;
};
const integerCentToFrenchFinanString = (integerCent) => {
    if (typeof integerCent !== "number") {
        throw new Error("integerCentToFrenchFinanString should be provided with a number");
    }
    const result = integerCentToFloatString(integerCent);
    if (result && result.match(/\./)) {
        return result.replace(".", ",");
    }
    else {
        return result + ",00";
    }
};
const smartRounder = (total, floats) => {
    if (typeof total !== "number") {
        throw new Error("smartRounder is provided with wrong total");
    }
    if (floats.length > 1) {
        const body = floats.slice(0, -1).map(Math.round);
        const last = total - body.reduce((a, b) => a + b);
        return body.concat(last);
    }
    if (floats.length === 1) {
        return [total];
    }
    if (floats.length === 0) {
        return [];
    }
    throw new Error("smartRounder is provided with only one float to round");
};
const financePercentage = (floatString, percentages) => {
    console.log("floastString", floatString);
    const totalCent = floatStringToIntegerCent(floatString);
    if (typeof totalCent === "undefined") {
        throw new TypeError("invalid floatString in financePercentage");
    }
    const calculated = percentages.map((percentage) => (totalCent * percentage) / 100);
    return smartRounder(totalCent, calculated).map(integerCentToFloatString);
};
const financePercentageCent = (totalCent, percentagesCents) => {
    if (typeof totalCent === "undefined") {
        throw new TypeError("invalid floatString in financePercentage");
    }
    const percentagesSum = percentagesCents.reduce((a, b) => a + b);
    if (percentagesSum !== 10000) {
        throw new TypeError("financePercentageCent should be provided with percentagesCents whose sum is 10 000 ");
    }
    const calculated = percentagesCents.map((percentage) => (totalCent * percentage) / 10000);
    return smartRounder(totalCent, calculated);
};
const floatStringAddition = (floatString1, floatString2) => {
    if (!functionnal.existy(floatStringToIntegerCent(floatString1)) ||
        !functionnal.existy(floatStringToIntegerCent(floatString2))) {
        throw new Error("floatStringAddition is provided with not parsable floatStrings");
    }
    return unsafeIntegerCentToFloatString(floatStringToIntegerCent(floatString1) +
        floatStringToIntegerCent(floatString2));
};
const test = {
    smartRounder,
};
export { floatStringToIntegerCent, integerCentToFloatString, unsafeIntegerCentToFloatString, unsafeFloatStringToIntegerCent, integerCentToFrenchFinanString, financePercentage, financePercentageCent, floatStringIsPositive, smartRounder, floatStringAddition, test, };
//# sourceMappingURL=financial.js.map